import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@state/store';
import App from './App';
import './index.css';

/**
 * Renderer process entry point
 * This initializes the React application
 */

// Add error handling
window.addEventListener('error', (e) => {
  console.error('❌ GLOBAL ERROR:', e.error);
  document.body.innerHTML = `<div style="color: red; padding: 20px; font-size: 24px;">
    ERROR: ${e.error.message}<br>
    ${e.error.stack}
  </div>`;
});

console.log('🔵 index.tsx: Starting v2...');

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('❌ Root element not found!');
  throw new Error('Root element not found');
}

console.log('🔵 Root element found:', rootElement);

try {
  // Create React root
  console.log('🔵 Creating React root...');
  const root = ReactDOM.createRoot(rootElement);

  console.log('🔵 Rendering app...');
  // Render the app
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );

  console.log("✅ Five Nights at Khan's - Renderer process initialized");
} catch (error) {
  console.error('❌ ERROR during React initialization:', error);
  document.body.innerHTML = `<div style="color: red; padding: 20px; font-size: 24px;">
    REACT ERROR: ${error}
  </div>`;
}

// Hot Module Replacement (HMR) for development
if ((import.meta as any).hot) {
  (import.meta as any).hot.accept();
}
